var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 5.53735H10.6322C9.18793 5.53735 8.0835 6.64179 8.0835 8.08604V21.679C8.0835 22.0189 8.25341 22.3587 8.59323 22.4437C8.93306 22.6136 9.27288 22.5286 9.52775 22.2737L14.0304 17.7711L18.5331 22.2737C18.703 22.4437 18.8729 22.5286 19.1278 22.5286C19.2128 22.5286 19.3827 22.5286 19.4676 22.4437C19.8075 22.2737 19.9774 22.0189 19.9774 21.679V8.08604C19.9774 6.64179 18.8729 5.53735 17.4287 5.53735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFill);
export default __webpack_public_path__ + "static/media/White Fill.f369c1dd125122cf913a9b8115b76efd.svg";
export { ForwardRef as ReactComponent };